export default __webpack_public_path__ + "static/media/ghost-short.7b8d3f0a.svg";